// extracted by mini-css-extract-plugin
export var parcelRow = "_ue-0";